import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../../../../app.service';
import { GenericIdName } from '../../../../shared/models/common-search-filters.model';
import { InspectionEventSearchFiltersVM, InspectionEventSearchResultVM, JobsiteSelectionFilter, ModelSelectionFilter, PerformSearchDigitalForm } from '../../../GET_NEW_UI/favourite-dialog/favourite-dialog-modal';
import { FavouriteDialogService } from '../../../GET_NEW_UI/favourite-dialog/favourite-dialog.service';
import { GETSetupEquipmentService } from '../../../GET_NEW_UI/setup-equipment/setup-equipment.service';
import { CustomerSelectItem } from '../../../setup-equipment/setup-equipment.model';
import { GenericIdName_ } from '../../../../../app/modules/IDENTITY_WEB/models/digitalForm.model';
import { ManageComponentsService } from '../../../../../app/modules/manage-components/manage-components.service';
import { MakeViewModel } from '../../../../../app/modules/manage-components/manage-components.model';
import { Make, Model } from '../../../../../app/entities';

@Component({
  selector: 'app-inspection-api',
  templateUrl: './inspection-api.component.html',
  styleUrls: ['./inspection-api.component.scss']
})
export class InspectionApiComponent implements OnInit {

  // Drop-down lists
  customerList: CustomerSelectItem[] = [];
  jobsiteList: GenericIdName[] = [];

  // Search Filters
  selectedCustomer: number[] = [];
  selectedJobsite: number[] = [];
  selectedFamilies: number[] = [];
  selectedModels: number[] = [];
  //search result
  loading: boolean = false;

  isDownloading = false;
  downloadStarted = false;

  noDataFound = false;
  customerRequired = false;
  inspectionTypeParam: number;
  api: number;
  modelList: Model[] = [];
  filterModelList: Model[] = [];
  filteredMakeViewModel: MakeViewModel[] = [];
  familyParam: string;
  modelParam: string;


  familyFilteredList: GenericIdName_[];
  makeList: Make[] = [];
  filterMakeList: Make[] = [];

  constructor(
    private _appService: AppService, private _equipmentService: GETSetupEquipmentService,
    public _favouriteDialogService: FavouriteDialogService,
    private _route: ActivatedRoute,
    private _http: HttpClient,
    private _router: Router, public _componentService: ManageComponentsService
  ) { }

  ngOnInit() {
    console.log('IN Inspections API Component');
    this._appService.setPageTitle('Inspections');
    this.loadCustomers();
    const customerParam = this._route.snapshot.paramMap.get('customer');
    const jobsiteParam = this._route.snapshot.paramMap.get('jobsite');
    const inspectionType = this._route.snapshot.paramMap.get('inspectiontype');
    this.familyParam = this._route.snapshot.paramMap.get('family');
    this.modelParam = this._route.snapshot.paramMap.get('model');
    this.inspectionTypeParam = inspectionType ? Number(inspectionType) : 3;
    this.selectedCustomer = customerParam ? customerParam.split(',').map(Number) : [];
    if (this.selectedCustomer.length > 0) {
      this.loadJobsitesForCustomer();
      this.selectedJobsite = jobsiteParam ? jobsiteParam.split(',').map(Number) : [];
      this.selectedFamilies = this.familyParam ? this.familyParam.split(',').map(Number) : [];
      this.selectedModels = this.modelParam ? this.modelParam.split(',').map(Number) : [];
    }
    this.api = Number(this._route.snapshot.queryParamMap.get('flag') ?? this._route.snapshot.queryParamMap.get('detailreport') ?? 0);
    this.getJSON();
    //if(this.api==0){
    //  this.getJSON();
    //}
    //else
    //  this.loadAllModel();

  }

  loadCustomers() {
    this.isDownloading = false;
    this.downloadStarted = false;
    this.noDataFound = false;
    this._equipmentService.getCustomerList().subscribe(r => {
      this.customerList = r;
      if (this.customerList.length == 1) {
        let onlyonecus = this.customerList[0].Id;
        let arrycus = [];
        arrycus.push(onlyonecus);
        this.selectedCustomer = arrycus;
        if (this.selectedCustomer.length > 0) {
          this.loadJobsitesForCustomer();
        }
      }
    });
  }

  loadJobsitesForCustomer() {
    if (this.selectedCustomer == null)
      return;
    this.isDownloading = false;
    this.downloadStarted = false;
    this.noDataFound = false;
    this.customerRequired = false;
    this.selectedJobsite = null;
    this.jobsiteList = null;
    var params: JobsiteSelectionFilter = {
      Customers: this.selectedCustomer,
    }
    this._favouriteDialogService.GetjobsitesAvailable(params).subscribe(r => {
      if (r) {
        this.jobsiteList = r;
        if (this.jobsiteList.length == 1) {
          let onlyonejob = this.jobsiteList[0].Id;
          let arry = [];
          arry.push(onlyonejob);
          this.selectedJobsite = arry;


        }
        //if ([1, 2, 3].includes(this.api)) {
        if (this.api != 0) {
          this.loadFamilyOnJobsite();
        }
      }
    });
  }

  loadFamilyOnJobsite() {
    if (this.api != 0) {
      this._favouriteDialogService.GetFamiliesForSelectedJobsite(this.selectedCustomer, this.selectedJobsite).subscribe(res => {
        this.familyFilteredList = res;
        //console.log("familyFilteredList", this.familyFilteredList);
        this.loadAllModel();
      });
    }
  }


  loadAllModel() {
    this._appService.getModelListForSelection(1, 10000).subscribe(result => {
      if (result && result.length > 0) {
        this.modelList = result;
        this.filterModelList = result;
        this.loadModelForfamily();
        //  if (this.api==1 ){
        //      this.getCrackMapJSON();
        //}else if (this.api==2 ) {
        //  this.getEquipmentInspectionJSON();
        //}else if (this.api==3){
        //  this.getEquipmentCurrentConditionJSON();
        //}
      }
    });
  }

  loadModelForfamily() {
    //console.log("modelList", this.modelList);
    // If no family is selected, show all models
    if (!this.selectedFamilies || this.selectedFamilies.length === 0) {
      this.filterModelList = [...this.modelList];
      return;
    }

    this.filterModelList = this.modelList.filter(model =>
      this.selectedFamilies.includes(model.FamilyId)
    );
    //console.log("filterModelList", this.filterModelList);
  }
  ResetFields() {
    this.selectedCustomer = [];
    this.selectedJobsite = [];
    this.selectedModels = [];
    this.selectedFamilies = [];
    this.isDownloading = false;
    this.downloadStarted = false;
    this.noDataFound = false;
    this.customerRequired = false;
  }

  //submitSelection() {
  //  this.loading = true;
  //  var params: InspectionEventSearchFiltersVM = {
  //    customers: this.selectedCustomer,
  //    jobsites: this.selectedJobsite,
  //  }

  //  this._favouriteDialogService.GetInspectionEventsSearchResult(params).subscribe(res => {
  //    this.PerformResult = res;
  //    if (this.PerformResult.length > 0)
  //      this.noRecords = false;
  //    else
  //      this.noRecords = true;
  //    this.loading = false;
  //  })
  //}

  getJSON(): void {
    this.noDataFound = false;
    this.customerRequired = false;
    if (!this.selectedCustomer || this.selectedCustomer.length === 0) {
      this.customerRequired = true;
      this.isDownloading = false;
      this.downloadStarted = false;
      this.noDataFound = false;
      return;
    }
    const url = [
      () => this.getBMAJSON(),
      () => this.getCrackMapJSON(),
      () => this.getEquipmentInspectionJSON(),
      () => this.getEquipmentCurrentConditionJSON(),
      () => this.getDetailedJSON()
    ][this.api]?.() ?? "";

    if (!url) {
      return;
    }
    //const url = 
    //  this._appService.getBaseURL() +
    //    'api/Inspection/Inspections?Customer=' +
    //    this.selectedCustomer.join(',') +
    //    '&Jobsite=' +
    //  (this.selectedJobsite?.length
    //    ? this.selectedJobsite.join(',')
    //    : '') +
    //  '&InspectionType=' +
    //  this.inspectionTypeParam;

    this.isDownloading = true;
    this.downloadStarted = false;
    this.noDataFound = false;

    this._http.get(url, {
      responseType: 'blob',
      observe: 'response'
    }).subscribe({
      next: response => {
        const blob = response.body!;

        const reader = new FileReader();
        reader.onload = () => {
          const text = reader.result as string;

          let parsed: any;
          try {
            parsed = JSON.parse(text);
          } catch {
            parsed = null;
          }

          if (
            parsed &&
            Array.isArray(parsed) &&
            parsed.length === 0
          ) {
            this.isDownloading = false;
            this.noDataFound = true;
            return;
          }

          let fileName = 'inspections.json';
          const contentDisposition = response.headers.get('content-disposition');
          if (contentDisposition) {
            const match = contentDisposition.match(
              /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
            );
            if (match?.[1]) {
              fileName = match[1].trim();
            }
          }
          fileName = fileName.replace(/_$/, '');

          const downloadURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = downloadURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(downloadURL);

          this.isDownloading = false;
          this.downloadStarted = true;
        };

        reader.readAsText(blob);
      },
      error: error => {
        this.isDownloading = false;

        if (error.status === 401) {
          const returnUrl = encodeURIComponent(this._router.url);
          window.location.href =
            this._appService.getBaseURL() +
            'Account/Signin?ReturnUrl=' +
            returnUrl;
        }

      }
    });
  }


  getCSV() {
    this.loading = true;
    this.loading = false;
  }
  getArrayFromStirng(stringToConvert: string, charToSplit: any) {
    if (stringToConvert == null)
      return "";
    else
      return stringToConvert.split(charToSplit);
  }

  getDetailedJSON(): string {
    return this._appService.getBaseURL() +
      'api/Inspection/Inspections?Customer=' +
      this.selectedCustomer.join(',') +
      '&Jobsite=' +
      (this.selectedJobsite?.length
        ? this.selectedJobsite.join(',')
        : '') +
      '&InspectionType=' +
      this.inspectionTypeParam +
      '&Flag=' +
      this.api +
      '&Family=' +
      this.selectedFamilies.join(',') +
      '&Model=' +
      this.selectedModels.join(',');
  }

  getBMAJSON(): string {
    return this._appService.getBaseURL() +
      'api/Inspection/Inspections?Customer=' +
      this.selectedCustomer.join(',') +
      '&Jobsite=' +
      (this.selectedJobsite?.length
        ? this.selectedJobsite.join(',')
        : '') +
      '&InspectionType=' +
      this.inspectionTypeParam;
  }

  getCrackMapJSON(): string {
    return this._appService.getBaseURL() +
      'api/GETEquipment/GetCrackMapData?CustomerIds=' +
      this.selectedCustomer.join(',') +
      '&JobsiteIds=' +
      (this.selectedJobsite?.length
        ? this.selectedJobsite.join(',')
        : '') +
      '&FamilyIds=' +
      this.selectedFamilies.join(',') +
      '&ModelIds=' +
      this.selectedModels.join(',');
    //this.noDataFound = false;
    //this.customerRequired = false;
    //if (!this.selectedCustomer || this.selectedCustomer.length === 0) {
    //  this.customerRequired = true;
    //  this.isDownloading = false;
    //  this.downloadStarted = false;
    //  this.noDataFound = false;
    //  return;
    //}
    //const url =
    //  this._appService.getBaseURL() +
    //    'api/GETEquipment/GetCrackMapData?CustomerIds=' +
    //    this.selectedCustomer.join(',') +
    //    '&JobsiteIds=' +
    //  (this.selectedJobsite?.length
    //    ? this.selectedJobsite.join(',')
    //    : '') +
    //  '&FamilyIds=' +
    //  this.selectedFamilies.join(',') +
    //  '&ModelIds=' +
    //  this.selectedModels.join(',');

    //this.isDownloading = true;
    //this.downloadStarted = false;
    //this.noDataFound = false;

    //this._http.get(url, {
    //  responseType: 'blob',
    //  observe: 'response'
    //}).subscribe({
    //  next: response => {

    //    const blob = response.body!;

    //    const reader = new FileReader();
    //    reader.onload = () => {
    //      const text = reader.result as string;

    //      let parsed: any;
    //      try {
    //        parsed = JSON.parse(text);
    //      } catch {
    //        parsed = null;
    //      }

    //      if (
    //        parsed &&
    //        Array.isArray(parsed) &&
    //        parsed.length === 0
    //      ) {
    //        this.isDownloading = false;
    //        this.noDataFound = true;
    //        return;
    //      }

    //      let fileName = 'inspections.json';
    //      const contentDisposition = response.headers.get('content-disposition');
    //      if (contentDisposition) {
    //        const match = contentDisposition.match(
    //          /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
    //        );
    //        if (match?.[1]) {
    //          fileName = match[1].trim();
    //        }
    //      }
    //      fileName = fileName.replace(/_$/, '');

    //      const downloadURL = window.URL.createObjectURL(blob);
    //      const link = document.createElement('a');
    //      link.href = downloadURL;
    //      link.download = fileName;
    //      document.body.appendChild(link);
    //      link.click();
    //      document.body.removeChild(link);
    //      window.URL.revokeObjectURL(downloadURL);

    //      this.isDownloading = false;
    //      this.downloadStarted = true;
    //    };

    //    reader.readAsText(blob);
    //  },
    //  error: error => {
    //    this.isDownloading = false;

    //    if (error.status === 401) {
    //      const returnUrl = encodeURIComponent(this._router.url);
    //      window.location.href =
    //        this._appService.getBaseURL() +
    //        'Account/SignIn?ReturnUrl=' +
    //        returnUrl;
    //    }

    //  }
    //});
  }


  getEquipmentCurrentConditionJSON(): string {
    return this._appService.getBaseURL() +
      'api/Interpretation/GetEquipmentCurrentCondition?CustomerIds=' +
      this.selectedCustomer.join(',') +
      '&JobsiteIds=' +
      (this.selectedJobsite?.length
        ? this.selectedJobsite.join(',')
        : '') +
      '&FamilyIds=' +
      this.selectedFamilies.join(',') +
      '&ModelIds=' +
      this.selectedModels.join(',');
    //this.noDataFound = false;
    //this.customerRequired = false;
    //if (!this.selectedCustomer || this.selectedCustomer.length === 0) {
    //  this.customerRequired = true;
    //  this.isDownloading = false;
    //  this.downloadStarted = false;
    //  this.noDataFound = false;
    //  return;
    //}
    //const url =
    //  this._appService.getBaseURL() +
    //    'api/Interpretation/GetEquipmentCurrentCondition?CustomerIds=' +
    //    this.selectedCustomer.join(',') +
    //    '&JobsiteIds=' +
    //  (this.selectedJobsite?.length
    //    ? this.selectedJobsite.join(',')
    //    : '') +
    //  '&FamilyIds=' +
    //  this.selectedFamilies.join(',') +
    //  '&ModelIds=' +
    //  this.selectedModels.join(',');

    //this.isDownloading = true;
    //this.downloadStarted = false;
    //this.noDataFound = true;

    //this._http.get(url, {
    //  responseType: 'blob',
    //  observe: 'response'
    //}).subscribe({
    //  next: response => {
    //    const blob = response.body!;
    //    if(blob!=null || blob!=undefined){
    //      this.noDataFound = false;
    //    }
    //    const reader = new FileReader();
    //    reader.onload = () => {
    //      const text = reader.result as string;

    //      let parsed: any;
    //      try {
    //        parsed = JSON.parse(text);
    //      } catch {
    //        parsed = null;
    //      }

    //      if (
    //        parsed &&
    //        Array.isArray(parsed) &&
    //        parsed.length === 0
    //      ) {
    //        this.isDownloading = false;
    //        this.noDataFound = true;
    //        return;
    //      }

    //      let fileName = 'inspections.json';
    //      const contentDisposition = response.headers.get('content-disposition');
    //      if (contentDisposition) {
    //        const match = contentDisposition.match(
    //          /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
    //        );
    //        if (match?.[1]) {
    //          fileName = match[1].trim();
    //        }
    //      }
    //      fileName = fileName.replace(/_$/, '');

    //      const downloadURL = window.URL.createObjectURL(blob);
    //      const link = document.createElement('a');
    //      link.href = downloadURL;
    //      link.download = fileName;
    //      document.body.appendChild(link);
    //      link.click();
    //      document.body.removeChild(link);
    //      window.URL.revokeObjectURL(downloadURL);

    //      this.isDownloading = false;
    //      this.downloadStarted = true;

    //    };

    //    reader.readAsText(blob);
    //  },
    //  error: error => {
    //    this.isDownloading = false;

    //    if (error.status === 401) {
    //      const returnUrl = encodeURIComponent(this._router.url);
    //      window.location.href =
    //        this._appService.getBaseURL() +
    //        'Account/SignIn?ReturnUrl=' +
    //        returnUrl;
    //    }

    //  }
    //});
  }
  getEquipmentInspectionJSON(): string {
    return this._appService.getBaseURL() +
      'api/Interpretation/GetInspectionData?CustomerIds=' +
      this.selectedCustomer.join(',') +
      '&JobsiteIds=' +
      (this.selectedJobsite?.length
        ? this.selectedJobsite.join(',')
        : '') +
      '&FamilyIds=' +
      this.selectedFamilies.join(',') +
      '&ModelIds=' +
      this.selectedModels.join(',');
    //this.noDataFound = false;
    //this.customerRequired = false;
    //if (!this.selectedCustomer || this.selectedCustomer.length === 0) {
    //  this.customerRequired = true;
    //  this.isDownloading = false;
    //  this.downloadStarted = false;
    //  this.noDataFound = false;
    //  return;
    //}
    //const url =
    //  this._appService.getBaseURL() +
    //    'api/Interpretation/GetInspectionData?CustomerIds=' +
    //    this.selectedCustomer.join(',') +
    //    '&JobsiteIds=' +
    //  (this.selectedJobsite?.length
    //    ? this.selectedJobsite.join(',')
    //    : '') +
    //  '&FamilyIds=' +
    //  this.selectedFamilies.join(',') +
    //  '&ModelIds=' +
    //  this.selectedModels.join(',');

    //this.isDownloading = true;
    //this.downloadStarted = false;
    //this.noDataFound = false;

    //this._http.get(url, {
    //  responseType: 'blob',
    //  observe: 'response'
    //}).subscribe({
    //  next: response => {
    //    const blob = response.body!;

    //    const reader = new FileReader();
    //    reader.onload = () => {
    //      const text = reader.result as string;

    //      let parsed: any;
    //      try {
    //        parsed = JSON.parse(text);
    //      } catch {
    //        parsed = null;
    //      }

    //      if (
    //        parsed &&
    //        Array.isArray(parsed) &&
    //        parsed.length === 0
    //      ) {
    //        this.isDownloading = false;
    //        this.noDataFound = true;
    //        return;
    //      }

    //      let fileName = 'inspections.json';
    //      const contentDisposition = response.headers.get('content-disposition');
    //      if (contentDisposition) {
    //        const match = contentDisposition.match(
    //          /filename\*?=(?:UTF-8'')?["']?([^;"']+)["']?/i
    //        );
    //        if (match?.[1]) {
    //          fileName = match[1].trim();
    //        }
    //      }
    //      fileName = fileName.replace(/_$/, '');

    //      const downloadURL = window.URL.createObjectURL(blob);
    //      const link = document.createElement('a');
    //      link.href = downloadURL;
    //      link.download = fileName;
    //      document.body.appendChild(link);
    //      link.click();
    //      document.body.removeChild(link);
    //      window.URL.revokeObjectURL(downloadURL);

    //      this.isDownloading = false;
    //      this.downloadStarted = true;
    //    };

    //    reader.readAsText(blob);
    //  },
    //  error: error => {
    //    this.isDownloading = false;

    //    if (error.status === 401) {
    //      const returnUrl = encodeURIComponent(this._router.url);
    //      window.location.href =
    //        this._appService.getBaseURL() +
    //        'Account/SignIn?ReturnUrl=' +
    //        returnUrl;
    //    }

    //  }
    //});
  }
  downLoadJSON() {
    this.getJSON();
    //if(this.api==0){
    //  this.getJSON();
    //}else if (this.api==1 ){
    //  this.getCrackMapJSON();
    //}else if (this.api==2 ) {
    //  this.getEquipmentInspectionJSON();
    //}else if (this.api==3){
    //  this.getEquipmentCurrentConditionJSON();
    //}else if(this.api== 4) {
    //  this.getDetailedJSON();
    //}
  }
}



